
import { defineComponent } from "vue";
import News from "@/entities/news";
import { newsService } from "@/services";
import SvgIcon from "@jamescoyle/vue-icon";
import { mdiArrowLeft } from "@mdi/js";
import { AxiosError } from "axios";

export default defineComponent({
  props: {
    newsId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      news: null as null | News,
      mdiArrowLeft,
    };
  },
  methods: {
    async getNew() {
      try {
        this.news = await newsService.getNews(this.newsId);
        console.log(this.news)
      } catch (error) {
        if ((error as AxiosError).isAxiosError) {
          const axiosError = error as AxiosError;
          if (axiosError.response?.status == 403) {
            this.$router.push("/");
          } else {
            console.log(`Error \n ${error}`);
          }
        }
      }
    },
    convertDate(date: string){
      const formatedDate = new Date(date).toLocaleDateString("es-ES", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      });
      const aux = formatedDate.toString();
      return aux[0].toUpperCase() + aux.substring(1);
    }
  },

  components: {
    SvgIcon,
  },
  async mounted() {
    await this.getNew();
  },
});
